import SystemApi from 'api.v2/system';
import { Loading } from 'common/components';
import I18nBase, { Language } from 'common/i18n';
import * as React from 'react';

interface iProps {
    language?: Language;
}

interface iState {
    isLocaleLoading: boolean;
}

export default (userLocales: (language: Language, mtsLang: Record<string, string>) => Promise<Object> = async (language: Language) => ({ [language]: {} })) =>
    (WrappedComponent: React.ComponentClass<any>): any => {
        class I18n extends React.Component<iProps, iState> {
            state: iState = {
                isLocaleLoading: true
            };

            async componentDidMount() {
                const languaeConfig = await SystemApi.languageConfig();

                // 当前语言类型直接读取NODE端设置—_uLang
                const language = window._uLang;
                const userLocale = await userLocales(language, languaeConfig.mtsLang);

                await I18nBase.init(language, userLocale, languaeConfig);

                this.setState({ isLocaleLoading: false });
            }

            render() {
                const { isLocaleLoading } = this.state;
                return isLocaleLoading
                    ? <Loading />
                    : <WrappedComponent {...this.props} />;
            }
        }

        return I18n;
    };
